import styled, { css } from 'styled-components';
import ProgressBar from 'react-bootstrap/ProgressBar';

export const SummaryTable = styled.table`
  thead tr th {
    color: #4B5675;
    font-weight: 600;
    font-size: 12.5px;
    text-transform: uppercase;
    padding: 4px 0px;   
  }

  tbody tr td {
    border-bottom: 1px solid #DBDFE9;   
    color: #4B5675;
    font-weight: 400;
    font-size: 14px;
    padding: 13px 0px;
  }

  tbody tr.active td {
    background: #eceef1;
  }

  tfoot tr td {
    color: #4B5675;
    font-weight: 600;
    font-size: 12.5px;
    text-transform: uppercase;   
    padding-top: 8px;
    border-top: 1px solid #DBDFE9;
  }
`;

export const StyledProgressBar = styled(ProgressBar)`
  height: 14px;

  & .progress {
  }

  #expense-1 {
    background-color: #FCEDB9;
    border-radius: 0;
  }

  #expense-2 {
    background-color: #FCBD3A;
    border-radius: 0;
  }

  #expense-3 {
    background-color: #FF8F0E;
    border-radius: 0;
  }

  #income-1 {
    background-color: #D7F7C2;
    border-radius: 0;
  }

  #income-2 {
    background-color: #76DF47;
    border-radius: 0;
  }

  #income-3 {
    background-color: #48C404;
    border-radius: 0;
  }

  #warning {
    background-color: rgb(0, 161, 194);
    border-radius: 0;
  }

  #danger {
    background-color: rgb(237, 104, 4);
    border-radius: 0;
  }

  #success {
    background-color: rgb(153, 102, 255);
    border-radius: 0;
    
  }

  ${({ isLast }) =>
    !isLast &&
    css`
    border-right: 1px solid #fff;  
  `}

  ${({ isLast }) =>
    isLast &&
    css`
    border-right: none !important;
  `}
`;

export const Circle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: ${({ color }) => color};
`;
